export default "__VITE_ASSET__DVIj80TG__"